import { HTMLChakraProps, chakra } from '@chakra-ui/react';
import { formatDistanceToNow } from 'date-fns';
import { FC, ReactNode } from 'react';

import { useTimeout } from '@/hooks/useTimeout';

interface IRelativeTimestampProps extends Omit<HTMLChakraProps<'div'>, 'children'> {
  timestamp: Date;
  updateInterval?: number;
  children: (formatedTime: string) => ReactNode;
}

/**
 * @deprecated - useTimeAgo hook is much optimized for re-renders
 */
export const RelativeTimestamp: FC<IRelativeTimestampProps> = ({
  timestamp,
  updateInterval = 6000,
  children,
  ...props
}) => {
  useTimeout(updateInterval);

  return <chakra.div {...props}>{children(formatDistanceToNow(timestamp))}</chakra.div>;
};
